export class ContractorLogin {
    userName: string;
    password: string;
}
